import { createReducer } from '@reduxjs/toolkit';
import { addMessage, updateMessage, clearMessage, deleteAllMessages, addInitialVifPrompt, updateStatus, clearStatus } from '../actions/messages';
import { getLocalStorageMessages } from '../../components/utils/localStorage';
import { addInitialVifPromptToMessagesList, findAndUpdateMessageResponse, findAndClearMessageResponse } from '../helpers/messages';
const initialState = {
    messages: getLocalStorageMessages(),
    statusMessage: '',
};
const messagesReducer = createReducer(initialState, builder => {
    builder
        .addCase(addMessage, (state, action) => {
        return Object.assign(Object.assign({}, state), { messages: [...state.messages, action.payload] });
    })
        .addCase(updateMessage, (state, action) => {
        return Object.assign(Object.assign({}, state), { messages: findAndUpdateMessageResponse(state.messages, action.payload) });
    })
        .addCase(clearMessage, (state, action) => {
        return Object.assign(Object.assign({}, state), { messages: findAndClearMessageResponse(state.messages, action.payload) });
    })
        .addCase(deleteAllMessages, (state) => (Object.assign(Object.assign({}, state), { messages: [] })))
        .addCase(updateStatus, (state, action) => (Object.assign(Object.assign({}, state), { statusMessage: action.payload })))
        .addCase(clearStatus, (state) => (Object.assign(Object.assign({}, state), { statusMessage: '' })))
        .addCase(addInitialVifPrompt, (state) => {
        return addInitialVifPromptToMessagesList(state);
    })
        .addDefaultCase((state) => state);
});
export default messagesReducer;
//# sourceMappingURL=messages.js.map